import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import { store } from './store/store';
import Auth0ProviderWithNavigate from './auth/auth0-provider-with-navigate';
import { ConfigProvider, LocaleProvider } from './contexts';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/global.scss';
import './styles/calendar.scss';
import './styles/date-range-input.scss';
import RouteScrollManager from './router/RouteScrollManager';

axios.defaults.baseURL = window.location.origin;

const rootElement = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider>
        <LocaleProvider>
          <BrowserRouter>
            <RouteScrollManager />
            <Auth0ProviderWithNavigate>
              <App />
            </Auth0ProviderWithNavigate>
          </BrowserRouter>
        </LocaleProvider>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
